import React, { Component } from 'react';
import firebaseApp from '../Firebase/Firebase';
import Chatbotdisplay from './Chatbotdisplay';
import Aboutus from '../About/Aboutus';

require('./home.css');
require('firebase/firestore');
//var Modal = require('boron/OutlineModal');

var db = firebaseApp.firestore();

/*//var Modal = require('boron/OutlineModal');
var style = { modalStyle: { width: 'auto', height: '15px' } }*/

class Home extends Component {
    constructor(props) {
        super(props);
        this.state = {
            sendGridAPIKey: ''
        };
        this.showModal = this.showModal.bind(this);
        this.signUp = this.signUp.bind(this);
    }

    // componentWillMount() {
    //     this.callApi()
    //         .then(res => {
    //             //Split the password and the username 
    //             var sendGridAPIKey = res.toString();
    //             this.setState({
    //                 sendGridAPIKey
    //             });
    //         })
    //         .catch(err => console.log(err));
    // }

    // callApi = async () => {
    //     const response = await fetch('/sendgrid/info');
    //     const body = await response.text();
    //     //console.log(body);

    //     if (response.status !== 200) throw Error(body.message);

    //     return body;
    // };

    showModal() {
        this.refs.modal.show();
    };

    signUp() {
        let email = document.getElementById('emailInput').value, referThis = this;
        let emailRef = db.collection('signUpEmails');
        if (email === "") {
            //Do nothing since it's empty
            document.getElementById('warning').style.display = 'block';
        } else {
            emailRef.doc(email).set({
                email: email
            }).then(function () {
                //Success signing up
                console.log('Success');
                document.getElementById('emailInput').value = "";
                referThis.showModal();
            }).catch(function (error) {
                window.alert('There was an error signing up!');
            });
        }
    }


    render() {
        return (
            <div /*className="fade-in"*/>
                <section id="body">
                    <Chatbotdisplay sendGridAPIKey={this.state.sendGridAPIKey}/>
                    <Aboutus />
                </section>

            </div>
        );
    }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Homepage/Home.js